import { render } from "./game.vue?vue&type=template&id=58b3dd6e&scoped=true"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"

import "./game.vue?vue&type=style&index=0&id=58b3dd6e&scoped=true&lang=css"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b3dd6e"]])

export default __exports__